import { useLocalStore } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';

import routerConst from 'APP/router/constants';
import Entities from 'STORE';

const LIMIT = 10;

export const useUsersPopoverPresenter = ({ usersIds, tooltip, groupId, messageId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const presenter = useLocalStore(() => ({
    get users() {
      return usersIds
        .slice(0, LIMIT)
        .map((userId) => Entities.usersStore.getUserById(userId))
        .filter((x) => x);
    },

    get isOpened() {
      return presenter.users.length > 0;
    },

    get moreCount() {
      if (usersIds.length > LIMIT) {
        return usersIds.length - LIMIT;
      }

      return null;
    },

    onMoreClick() {
      const { state, stateEnum } = routerConst;

      navigate(location.pathname, {
        state: {
          [state.popup]: stateEnum.popup.newUsers,
          [state.usersIds]: usersIds,
          [state.groupId]: groupId,
          [state.messageId]: messageId,
        },
      });

      tooltip.hide();
    },

    onUserClick() {
      tooltip.hide();
    },
  }));

  return presenter;
};
